import { lazier } from '@shared/components';

export const RecharterPage = lazier(() => import('./RecharterPage'));
export { default as RecharterNotification } from './RecharterNotification';
export { default as RecharterModals } from './RecharterModals';
